export default __webpack_public_path__ + "file/Brochure-Puroak-EN.asset.c0f97c51.pdf";